import { Navigate, Route, Routes } from "react-router";
import { Layout } from "./components/Layout";
import { CookieBanner } from "./components/CookieBanner";
import { UpdatePrompt } from "./components/UpdatePrompt";
import { AuthProvider } from "./lib/auth";
import { Home } from "./pages/Home";
import { Login } from "./pages/Login";
import { CheckEmail } from "./pages/CheckEmail";
import { Dashboard } from "./pages/Dashboard";
import { Browse } from "./pages/Browse";
import { BookDetail } from "./pages/BookDetail";
import { AdminLayout } from "./pages/admin/Layout";
import { AdminInventory } from "./pages/admin/Inventory";
import { AdminCheckout } from "./pages/admin/Checkout";
import { AdminHolds } from "./pages/admin/Holds";
import { AdminStats } from "./pages/admin/Stats";
import { AdminCredits } from "./pages/admin/Credits";
import { AdminBooks } from "./pages/admin/Books";
import { AdminHours } from "./pages/admin/Hours";
import { Donate } from "./pages/Donate";
import { Appointments } from "./pages/Appointments";
import { Privacy } from "./pages/Privacy";
import { Terms } from "./pages/Terms";
import { DataDeletion } from "./pages/DataDeletion";
import { Contact } from "./pages/Contact";
import { NotFound } from "./pages/NotFound";
import "./components/cookie-banner.css";

export function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="login" element={<Login />} />
          <Route path="login/check-email" element={<CheckEmail />} />
          <Route path="browse" element={<Browse />} />
          <Route path="book/:id" element={<BookDetail />} />
          <Route path="donate" element={<Donate />} />
          <Route path="marcacoes" element={<Appointments />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/checkin" replace />} />
            <Route path="checkin" element={<AdminInventory />} />
            <Route path="checkout" element={<AdminCheckout />} />
            <Route path="holds" element={<AdminHolds />} />
            <Route path="livros" element={<AdminBooks />} />
            <Route path="creditos" element={<AdminCredits />} />
            <Route path="horarios" element={<AdminHours />} />
            <Route path="stats" element={<AdminStats />} />
          </Route>
          <Route path="privacidade" element={<Privacy />} />
          <Route path="termos" element={<Terms />} />
          <Route path="eliminar-dados" element={<DataDeletion />} />
          <Route path="contacto" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
      <CookieBanner />
      <UpdatePrompt />
    </AuthProvider>
  );
}
